<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive">
        <!-- 这里是会被缓存的视图组件，比如page,page1,page2 -->
      </router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <loading v-show="LOADING"></loading>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import loading from './components/loading'

export default {
  name: 'App',
  computed: {
    ...mapState(['LOADING']),
  },
  components: {
    loading,
  },
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/App.vue